<div *ngIf="isLoading; else doneLoading">
  <div
    class="spinner-border text-primary"
    role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<ng-template #doneLoading>
  <div class="clear-row wide">
    <span
      *ngIf="!isDelete"
      class="lx-title">
      Review Release {{ release.name }}
    </span>
    <span
      *ngIf="isDelete"
      class="lx-title deletion">
      Delete Release {{ release?.name }}
    </span>
    <i
      class="lx-icon lx-close-x"
      style="cursor: pointer"
      (click)="close()"></i>
  </div>

  <dcc-status-indicator
    [color]="statusColor"
    [value]="statusString"></dcc-status-indicator>

  <span class="divider"></span>

  <div>
    <p class="lx-label">REQUEST CREATOR</p>
    <span class="clear-row lx-body">
      <span>{{ requestCreator }}</span>
      <span>{{ timestamp | date: 'MMMM d, y, h:mm:ss a' }}</span>
    </span>
  </div>

  <div *ngIf="releaseStatusChange && releaseStatusChange.changeType !== 'None'">
    <p class="lx-label">STATUS CHANGE</p>
    <div class="approval__shaded__row lx-body">
      <dcc-status-indicator
        [color]="getStatusColor(changes.releaseStatusChange.currentStatus)"
        [value]="
          changes.releaseStatusChange.currentStatus
        "></dcc-status-indicator>
      <div>-></div>
      <dcc-status-indicator
        [color]="getStatusColor(changes.releaseStatusChange.proposedStatus)"
        [value]="
          changes.releaseStatusChange.proposedStatus
        "></dcc-status-indicator>
    </div>
  </div>

  <div>
    <p class="lx-label">RELEASE NOTES</p>
    <label class="lx-body">{{ description }}</label>
  </div>

  <div
    *ngIf="isDelete"
    class="approval__shaded__column lx-body"
    style="gap: 0px">
    <span class="approval__shaded__module lx-label">DELETE RELEASE</span>
    <span class="approval__shaded__module">{{ release?.name }}</span>
  </div>

  <div
    *ngIf="
      modulesAdded.length > 0 ||
      modulesEdited.length > 0 ||
      modulesRemoved.length > 0
    ">
    <p class="lx-label">APPS</p>
    <div class="approval__shaded__column lx body">
      <ng-container *ngIf="modulesEdited.length > 0">
        <div class="approval__shaded__section">
          <span class="edited-title lx-body">
            <span class="lx-icon lx-edit"></span>
            Edited
          </span>
          <ng-container *ngFor="let m of modulesEdited">
            <span
              class="approval__shaded__module lx-header"
              style="text-transform: none">
              {{ m.name }}
            </span>
            <div
              class="approval__shaded__row no-padding"
              style="align-items: flex-start">
              <module-change-details
                class="no-padding transparent"
                [config]="m.configurationChange.currentConfiguration"
                [current]="true"
                [hasConfig]="hasCurrentConfig(m)"
                [isEdit]="true"
                [name]="m.name"
                [version]="
                  m.versionChange.currentVersion
                "></module-change-details>
              <module-change-details
                class="no-padding transparent"
                [config]="m.configurationChange.proposedConfiguration"
                [current]="false"
                [hasConfig]="hasProposedConfig(m)"
                [isEdit]="true"
                [name]="m.name"
                [version]="
                  m.versionChange.proposedVersion
                "></module-change-details>
            </div>
          </ng-container>
        </div>
        <span
          *ngIf="modulesRemoved.length > 0 || modulesAdded.length > 0"
          class="details-divider"></span>
      </ng-container>

      <ng-container *ngIf="modulesRemoved.length > 0">
        <div class="approval__shaded__section">
          <span class="removed-title lx-body">- Removed</span>
          <ng-container *ngFor="let m of modulesRemoved">
            <module-change-details
              class="no-padding transparent"
              [name]="m.name"
              [version]="
                m.versionChange.currentVersion
              "></module-change-details>
          </ng-container>
        </div>
        <span
          *ngIf="modulesAdded.length > 0"
          class="details-divider"></span>
      </ng-container>

      <ng-container *ngIf="modulesAdded.length > 0">
        <div class="approval__shaded__section">
          <span
            *ngIf="isNotNewRelease()"
            class="added-title lx-body">
            + Added
          </span>
          <ng-container *ngFor="let m of modulesAdded">
            <module-change-details
              class="no-padding transparent"
              [config]="m.configurationChange.proposedConfiguration"
              [hasConfig]="hasProposedConfig(m)"
              [name]="m.name"
              [version]="
                m.versionChange.proposedVersion
              "></module-change-details>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <span class="divider"></span>
  <ng-container *ngFor="let phase of phaseChanges">
    <ng-container
      *ngIf="
        !deploymentDateChange(phase) ||
          phase.changeType === 'Add' ||
          phase.changeType === 'Remove';
        else showDateChange
      ">
      <div class="clear-row wide">
        <span class="clear-row">
          <span
            class="lx-title"
            [ngStyle]="{
              'text-decoration':
                phase.changeType === 'Remove' ? 'line-through' : 'normal',
            }">
            {{ phase.name }}
          </span>
          <dcc-status-indicator
            class="lx-body"
            [color]="getStatusColor(phase.phase.status)"
            [ngStyle]="{
              'text-decoration':
                phase.changeType === 'Remove' ? 'line-through' : 'normal',
            }"
            [value]="phase.phase.status"></dcc-status-indicator>
          <span
            *ngIf="
              phase.changeType === 'Add' &&
              release.status !== 'Pending' &&
              release.hasPendingApproval
            "
            class="added-title lx-body">
            + Added
          </span>
          <span
            *ngIf="phase.changeType === 'Remove'"
            class="removed-title lx-body">
            - Removed
          </span>
        </span>
        <span
          class="lx-body"
          [ngStyle]="{
            'text-decoration':
              phase.changeType === 'Remove' ? 'line-through' : 'normal',
          }">
          Expected Release Date:
          {{ getDeploymentDate(phase) | date: 'MMMM d, y' }}
        </span>
      </div>
    </ng-container>

    <ng-template
      #showDateChange
      class="no-padding">
      <div class="clear-row wide">
        <span class="clear-row">
          <span class="lx-title">{{ phase.name }}</span>
          <dcc-status-indicator
            class="lx-body"
            [color]="getStatusColor(phase.phase.status)"
            [value]="phase.phase.status"></dcc-status-indicator>
        </span>
        <span class="lx-body">
          <span class="removed-title lx-body">- Removed</span>
          Expected Release Date:
          {{ getDeploymentDate(phase) | date: 'MMMM d, y' }}
        </span>
      </div>

      <div
        class="lx-body"
        style="display: flex; justify-content: right">
        <span class="added-title lx-body">+ Added</span>
        Expected Release Date:
        {{ getDeploymentDate(phase) | date: 'MMMM d, y' }}
      </div>
    </ng-template>

    <div
      class="approval__shaded__column"
      style="gap: 0px">
      <ng-container *ngFor="let cohort of phase.phase.cohorts">
        <li
          class="approval__shaded__phase lx-body"
          [ngStyle]="{
            'text-decoration':
              phase.changeType === 'Remove' ? 'line-through' : 'normal',
          }">
          {{ cohort }}
        </li>
      </ng-container>
      <ng-container *ngIf="phase.changeType === 'Edit'">
        <span
          *ngIf="
            (phase.cohortsAdded.length > 0 ||
              phase.cohortsRemoved.length > 0) &&
            isNotNewRelease()
          "
          class="details-divider"></span>
        <span
          *ngIf="phase.cohortsRemoved.length > 0"
          class="removed-title"
          style="margin-top: 10px">
          - Removed
        </span>
        <ng-container *ngFor="let cr of phase.cohortsRemoved">
          <li class="approval__shaded__phase lx-body">{{ cr }}</li>
        </ng-container>

        <span
          *ngIf="
            phase.cohortsAdded.length > 0 && phase.cohortsRemoved.length > 0
          "
          class="details-divider"></span>

        <ng-container *ngIf="isNotNewRelease()">
          <span
            *ngIf="phase.cohortsAdded.length > 0"
            class="added-title"
            style="margin-top: 10px">
            + Added
          </span>
          <ng-container *ngFor="let ca of phase.cohortsAdded">
            <li class="approval__shaded__phase lx-body">{{ ca }}</li>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <div class="lx-title">Estimated Release Total</div>
  <div
    class="approval__shaded__row lx-body"
    style="padding: 20px; background-color: rgba(229, 233, 242, 0.5)">
    <span>Potential Impacted Devices:</span>
    <span>{{ estimatedTotal }}</span>
  </div>

  <div
    *renderingPermissionDirective="['ModuleUpdateAdmin']"
    class="approval__shaded__column lx-body"
    style="gap: 0px">
    <label
      class="approval__shaded__row small-gap"
      [ngStyle]="{
        'font-weight': currentApprovalOption === 'Approved' ? '700' : 'normal',
      }">
      <input
        name="approvalOption"
        type="radio"
        value="Approved"
        [checked]="currentApprovalOption === 'Approved'"
        (change)="onApprovalOptionChange($event)" />
      Approve
    </label>
    <label
      class="approval__shaded__row small-gap"
      [ngStyle]="{
        'font-weight': currentApprovalOption === 'Rejected' ? '700' : 'normal',
      }">
      <input
        name="approvalOption"
        type="radio"
        value="Rejected"
        [checked]="currentApprovalOption === 'Rejected'"
        (change)="onApprovalOptionChange($event)" />
      Reject
    </label>
  </div>

  <div class="clear-row lx-body">
    <button
      class="lx-btn lx-btn-secondary approval-btn"
      (click)="close()">
      Close
    </button>
    <button
      *renderingPermissionDirective="['ModuleUpdateAdmin']"
      class="lx-btn lx-btn-primary approval-btn"
      (click)="onSave()">
      Save
    </button>
  </div>
</ng-template>
